import { useQuery } from 'react-query';

// Services
import { apiGetPersona } from '../../../../services/apis';

export function useGetPersonas(props, onSuccess) {
  return useQuery({
    queryKey: ['personas', props],
    queryFn: () => apiGetPersona(props),
    enabled: false,
    onSuccess,
  });
}
